export interface WizardStepDef {
  label: string
  sublabel: string
}

interface WizardStepRailProps {
  currentStep: number
  steps: WizardStepDef[]
  onStepClick: (step: number) => void
}

export function WizardStepRail({ currentStep, steps, onStepClick }: WizardStepRailProps) {
  return (
    <nav aria-label="Event creation steps" className="flex flex-col gap-1" style={{ width: 220, flexShrink: 0 }}>
      {steps.map((step, i) => {
        const active = i === currentStep
        const done = i < currentStep

        return (
          <button
            key={i}
            type="button"
            onClick={() => onStepClick(i)}
            aria-current={active ? 'step' : undefined}
            className="flex items-center gap-3 px-3 py-[11px] rounded-xl text-left border-0 cursor-pointer font-sans transition-colors"
            style={{ background: active ? 'linear-gradient(135deg, #e8e3f7, #ddd6f5)' : 'transparent' }}
          >
            <StepBadge index={i + 1} active={active} done={done} />
            <div>
              <div className="text-[13.5px] font-semibold text-ink leading-snug">{step.label}</div>
              <div className="text-[11.5px] text-muted leading-snug">{step.sublabel}</div>
            </div>
          </button>
        )
      })}
    </nav>
  )
}

function StepBadge({ index, active, done }: { index: number; active: boolean; done: boolean }) {
  const base = 'w-[26px] h-[26px] rounded-full flex items-center justify-center text-[13px] font-bold shrink-0'

  if (done) {
    return (
      <span className={`${base} text-[#16a34a]`} style={{ background: '#dcfce7' }}>
        ✓
      </span>
    )
  }

  if (active) {
    return (
      <span
        className={`${base} text-white`}
        style={{ background: 'linear-gradient(135deg, #3B4CCA, #7C5CD3)' }}
      >
        {index}
      </span>
    )
  }

  return (
    <span className={`${base} text-muted`} style={{ border: '1.5px solid var(--line)' }}>
      {index}
    </span>
  )
}
